import React from 'react';

import { useTranslation } from 'react-i18next';

import { Fade } from '@material-ui/core';

import { PageContainer, Search } from 'app/styles';

import SearchBox from 'components/Tools/Search';
import LoaderPda from 'components/Tools/LoaderPda';
import FixedHeader from 'components/Tools/Breadcrumb';

import { useParametersHooks } from './hooks/parameters.hooks';

import ParametersTable from './components/TableParameters';

const Parameters: React.FC = () => {
  const { t } = useTranslation();

  const {
    searchRef,
    parameters,
    isLoading,
    showTable,
    handleSearch,
    handleSaveChanges,
    handleClearParameter,
    handleUpdateParameters,
  } = useParametersHooks();

  return (
    <>
      <FixedHeader title={String(t('screens.parameters.parameter'))} />
      <Fade in timeout={1000} unmountOnExit>
        <PageContainer>
          <Search>
            <SearchBox
              searchBoxRef={searchRef}
              inputs={[
                {
                  name: 'description',
                  label: String(t('screens.profile.description')),
                  placeholder: String(t('screens.profile.description')),
                  type: 'text',
                  xl: 6,
                  lg: 4,
                  xs: 12,
                  md: 6,
                  sm: 12,
                },
              ]}
              handleSubmit={(params: { description?: string }) => {
                handleSearch(params.description);
              }}
              searchDisabled={isLoading}
            />
          </Search>
          {isLoading && <LoaderPda />}
          {!isLoading && showTable && (
            <ParametersTable
              parametersData={parameters}
              handleSaveChanges={handleSaveChanges}
              handleClearParameter={handleClearParameter}
              handleUpdateParameters={handleUpdateParameters}
            />
          )}
        </PageContainer>
      </Fade>
    </>
  );
};

export default Parameters;
